module.exports = __webpack_public_path__ + "static/media/restaurant-4.a085a175.jpg";